import { ExperienceIndexDataClient, LegacyExperienceDataProvider, type IExperienceDataProvider, SimpleExperienceDataProvider } from '@source-digital/experience-core'
import { type EmbedElementContext } from '../../../../element-embedder'
import { getSdApiUrlFromEnv } from '@source-digital/experience-utils/url'

/**
 * Interface for creating an instance of {@link IExperienceDataProvider}
 * @see {@link DefaultExperienceDataProviderFactory}
 *  {@link IExperienceDataProvider} defines how the Experience data is fetched.
 */
export interface IExperienceDataProviderFactory {
  create(ctx: EmbedElementContext): Promise<IExperienceDataProvider>
}

/**
 * Default implementation of {@link IExperienceDataProviderFactory}
 */
export class DefaultExperienceDataProviderFactory implements IExperienceDataProviderFactory {
  constructor (public readonly options: { static?: boolean } = {}) {}

  async create (ctx: EmbedElementContext): Promise<IExperienceDataProvider> {
    if (ctx.settings?.experience?.data != null) {
      const data = ctx.settings.experience.data
      data.distribution = data.distribution ?? { id: ctx.distributionId }
      return new SimpleExperienceDataProvider(data)
    }
    if (ctx.distributionId == null) {
      throw new Error('distributionId could not be determined')
    }
    const apiBase = getSdApiUrlFromEnv(ctx.settings.env)
    if (apiBase == null) {
      throw new Error('apiBase could not be determined')
    }
    const dataClient = new ExperienceIndexDataClient(apiBase)
    const indexData = await dataClient.fetch(ctx.distributionId, { static: this.options.static ?? true })
    return new LegacyExperienceDataProvider(indexData)
  }
}
